<div class="relative flex w-full flex-col">
  <!-- Spinner -->
  @if (trialLoading || componentsLoading) {
    <div class="absolute z-10 flex h-full w-full items-center" style="background-color: #f3f6f7">
      @if (componentsLoading && !trialLoading) {
        <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
      }
    </div>
  }

  <!-- Timeline Component -->
  <aux-trial-insights-clinical-timeline />

  <br />

  <div class="grid grid-cols-fluid gap-[25px]">
    <!-- Patient Cost Component -->
    <aux-trial-insights-clinical-patient-cost />

    <div>
      <!-- Investigator Cost Component -->
      <aux-trial-insights-clinical-investigator-cost />

      <br />

      <!-- Screen Fail Component -->
      <aux-trial-insights-clinical-screen-fail />
    </div>

    <!-- Site Cost Component -->
    <aux-trial-insights-clinical-site-cost />
  </div>
</div>
